var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ConsentManagerBuilder } from '@segment/consent-manager';
import { useCallback, useEffect } from 'react';
import noop from 'lodash/noop';
import ConsentManager from './ConsentManager';
import LocaleProvider from './LocaleProvider';
import initAnalytics from '../utils/initAnalytics';
import mapCustomPreferences from '../utils/mapCustomPreferences';
import saveCustomPreferences from '../utils/saveCustomPreferences';
var Root = function (_a) {
    var intlProps = _a.intlProps, _b = _a.isEnabled, isEnabled = _b === void 0 ? true : _b, segmentKey = _a.segmentKey, _c = _a.onAcceptAll, onAcceptAll = _c === void 0 ? noop : _c, _d = _a.onDenyAll, onDenyAll = _d === void 0 ? noop : _d, _e = _a.onLoad, onLoad = _e === void 0 ? noop : _e, _f = _a.onSetPreferences, onSetPreferences = _f === void 0 ? noop : _f;
    // Initially set preferences to false before the user has consented
    var initialPreferences = saveCustomPreferences();
    var shouldRequireConsent = function () { return isEnabled; };
    var handleSetPreferences = useCallback(function (preferences) {
        var acceptedAll = Object.values(preferences).every(function (accepted) { return accepted; });
        var deniedAll = Object.values(preferences).every(function (accepted) { return !accepted; });
        if (acceptedAll) {
            onAcceptAll();
        }
        else if (deniedAll) {
            onDenyAll();
        }
        else {
            onSetPreferences(preferences);
        }
    }, [onAcceptAll, onDenyAll, onSetPreferences]);
    // Initially add the Segment analytics snippet to the document head if it doesn't already exist
    useEffect(function () {
        initAnalytics();
        onLoad();
    }, [onLoad]);
    return (_jsx(LocaleProvider, __assign({}, intlProps, { children: _jsx(ConsentManagerBuilder, { defaultDestinationBehavior: "imply", initialPreferences: initialPreferences, mapCustomPreferences: mapCustomPreferences, shouldRequireConsent: shouldRequireConsent, writeKey: segmentKey, children: function (_a) {
                var isConsentRequired = _a.isConsentRequired, preferences = _a.preferences, saveConsent = _a.saveConsent, setPreferences = _a.setPreferences;
                return (_jsx(ConsentManager, { isConsentRequired: isConsentRequired, preferences: preferences, saveConsent: saveConsent, setPreferences: function (newPreferences) {
                        setPreferences(newPreferences);
                        handleSetPreferences(newPreferences);
                    } }));
            } }) })));
};
export default Root;
